import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import moment from "moment";
import { defaultAssignableColors } from "../utils";
import { schema, denormalize } from "normalizr";
import Amplitude from "@Shared/utils/amplitude";
import { cloneDeep, isEmpty, orderBy, toLower, values } from "lodash";
import { SORT_ORDER_E } from "@Shared/js/enum";
export var SORT_CRITERIA_E;
(function (SORT_CRITERIA_E) {
  SORT_CRITERIA_E["activity"] = "activity";
  SORT_CRITERIA_E["upcomingDate"] = "upcomingDate";
  SORT_CRITERIA_E["lastName"] = "lastName";
  SORT_CRITERIA_E["referrer"] = "referrer";
  SORT_CRITERIA_E["closingDate"] = "closingDate";
  SORT_CRITERIA_E["createdAt"] = "createdAt";
})(SORT_CRITERIA_E || (SORT_CRITERIA_E = {}));
const getReferrerFullName = ({
  referrer: {
    familyName,
    givenName
  }
}) => `${getCleanString(givenName)} ${getCleanString(familyName)}`;
const getCleanString = string => {
  var _context;
  return _trimInstanceProperty(_context = toLower(string)).call(_context);
};
const getCleanPhoneNumber = string => {
  var _context2, _context3, _context4, _context5, _context6;
  return _replaceAllInstanceProperty(_context2 = _replaceAllInstanceProperty(_context3 = _replaceAllInstanceProperty(_context4 = _replaceAllInstanceProperty(_context5 = _trimInstanceProperty(_context6 = toLower(string)).call(_context6)).call(_context5, /[(]+/g, "")).call(_context4, /[)]+/g, "")).call(_context3, "-", "")).call(_context2, " ", "");
};
const emptiesAtTopSorter = clientProfile => {
  return clientProfile.reminders.length;
};
const pickSortFunctions = (emptyAtTop, sortFn, order = SORT_ORDER_E.asc) => {
  const sortFunctions = [];
  const orderCriteria = [];
  if (emptyAtTop) {
    sortFunctions.push(emptiesAtTopSorter);
    orderCriteria.push(order);
  }
  sortFunctions.push(sortFn);
  orderCriteria.push(order);
  return [sortFunctions, orderCriteria];
};
const collaborator = new schema.Entity("collaborator");
const collaboratorsSchema = new schema.Entity("collaborators", {
  collaborators: [collaborator]
}, {
  idAttribute: "username"
});
export default {
  methods: {
    filterProfileCards(profiles, activeFilters) {
      return _filterInstanceProperty(profiles).call(profiles, ({
        reminders,
        referrerId,
        owner,
        collaborators,
        cardColour,
        customFields
      }) => {
        var _customFields$find, _context7, _context8, _context9;
        const upcomingClassification = this.$options.filters.followupClassification((_customFields$find = _findInstanceProperty(customFields).call(customFields, x => x.name === "Upcoming Date")) == null ? void 0 : _customFields$find.value);
        const remindersClassification = _trimInstanceProperty(_context7 = this.$options.filters.activityClass(reminders, false)).call(_context7).split(" ");
        const showForUpcomingMilestones = activeFilters.upcomingMilestones.all || activeFilters.upcomingMilestones[upcomingClassification];
        const showForActivities = activeFilters.activities.all || remindersClassification.some(classification => activeFilters.activities[classification]);
        const showForReferrers = !activeFilters.referrers.length || _includesInstanceProperty(_context8 = activeFilters.referrers).call(_context8, String(referrerId));
        const showForAgent = !activeFilters.agents.length || _includesInstanceProperty(_context9 = activeFilters.agents).call(_context9, String(owner.username));
        const {
          allIds,
          byId
        } = collaborators;
        const allCollaborators = denormalize(allIds, [collaboratorsSchema], {
          collaborators: byId
        });
        const showForCollaborators = !activeFilters.collaborators.length || allCollaborators.some(({
          username
        }) => {
          var _context0;
          return _includesInstanceProperty(_context0 = activeFilters.collaborators).call(_context0, String(username));
        });
        const showForColors = !activeFilters.colors.length || this.isCurrentColorIncluded(activeFilters.colors, cardColour);
        return showForUpcomingMilestones && showForActivities && showForReferrers && showForAgent && showForCollaborators && showForColors;
      });
    },
    searchClientProfile(profiles, searchString) {
      return _filterInstanceProperty(profiles).call(profiles, ({
        givenName,
        familyName,
        email,
        phoneNumber,
        referrer,
        coApplicants = []
      }) => {
        const values = [givenName, familyName, email, getCleanPhoneNumber(phoneNumber), referrer == null ? void 0 : referrer.givenName, referrer == null ? void 0 : referrer.familyName, ..._mapInstanceProperty(coApplicants).call(coApplicants, coApplicant => `${coApplicant.givenName} ${coApplicant.familyName} ${coApplicant.email}`)];
        if (searchString.match(/(\(\d{1,3})(\) \d{1,3})(-\d{1,4})?/) || searchString.match(/(\d{1,3})(-\d{1,3})(-\d{1,4})?/)) {
          searchString = getCleanPhoneNumber(searchString);
        }
        const flatString = _mapInstanceProperty(values).call(values, getCleanString).join(" ");
        return _includesInstanceProperty(flatString).call(flatString, getCleanString(searchString));
      });
    },
    sortProfileCardsBy(profiles, {
      criteria,
      emptyAtTop = false,
      order = SORT_ORDER_E.asc
    }) {
      const sortFnMapper = {
        activity: this._sortByActivityFn(emptyAtTop, order),
        upcomingDate: this._sortByUpcomingFn(emptyAtTop, order),
        lastName: this._sortByLastNameFn(emptyAtTop, order),
        referrer: this._sortByReferrerNameFn(emptyAtTop, order),
        closingDate: this._sortByClosingFn(emptyAtTop, order),
        createdAt: this._sortByCreatedFn(emptyAtTop, order),
        clientValue: this._sortByClientValueFn(emptyAtTop, order),
        clientLabel: this._sortByClientLabelFn(emptyAtTop, order)
      };
      const sortFn = sortFnMapper[criteria];
      return sortFn(cloneDeep(profiles));
    },
    _sortByActivityFn(emptyAtTop, order) {
      const RULES_WEIGHT = {
        "past-due": 1,
        active: 2,
        upcoming: 3,
        planned: 4,
        "empty-last": 5,
        "empty-first": 0
      };
      return array => orderBy(array, [({
        reminders
      }) => {
        const currentRules = this.$options.filters.activityClass(reminders, false);
        if (isEmpty(reminders)) {
          return emptyAtTop ? RULES_WEIGHT["empty-first"] : RULES_WEIGHT["empty-last"];
        }
        if (_includesInstanceProperty(currentRules).call(currentRules, "past-due")) {
          return RULES_WEIGHT["past-due"];
        }
        if (_includesInstanceProperty(currentRules).call(currentRules, "active")) {
          return RULES_WEIGHT["active"];
        }
        if (_includesInstanceProperty(currentRules).call(currentRules, "upcoming")) {
          return RULES_WEIGHT["upcoming"];
        }
        if (_includesInstanceProperty(currentRules).call(currentRules, "planned")) {
          return RULES_WEIGHT["planned"];
        }
        throw new Error("Invalid activity");
      }], [order]);
    },
    _sortByUpcomingFn(emptyAtTop, order) {
      const findUpcomingDate = customFields => {
        var _customFields$find2;
        return (_customFields$find2 = _findInstanceProperty(customFields).call(customFields, x => x.name === "Upcoming Date")) == null ? void 0 : _customFields$find2.value;
      };
      const isEmptyDate = upcomingDate => {
        return isEmpty(upcomingDate);
      };
      const dateTimestamp = upcomingDate => {
        return moment(upcomingDate).unix();
      };
      const byUpcomingSort = ({
        customFields
      }) => {
        const upcomingDate = findUpcomingDate(customFields);
        return isEmptyDate(upcomingDate) ? Infinity : dateTimestamp(upcomingDate);
      };
      return array => orderBy(array, ...pickSortFunctions(emptyAtTop, byUpcomingSort, order));
    },
    _sortByClosingFn(emptyAtTop, order) {
      const findClosingDate = customFields => {
        var _customFields$find3;
        return (_customFields$find3 = _findInstanceProperty(customFields).call(customFields, x => x.name === "Closing Date")) == null ? void 0 : _customFields$find3.value;
      };
      const isEmptyDate = closingDate => {
        return isEmpty(closingDate);
      };
      const dateTimestamp = closingDate => {
        return moment(closingDate).unix();
      };
      const byClosingSort = ({
        customFields
      }) => {
        const closingDate = findClosingDate(customFields);
        return isEmptyDate(closingDate) ? Infinity : dateTimestamp(closingDate);
      };
      return array => orderBy(array, ...pickSortFunctions(emptyAtTop, byClosingSort, order));
    },
    _sortByCreatedFn(emptyAtTop, order) {
      const isEmptyDate = createdAt => isEmpty(createdAt);
      const dateTimestamp = createdAt => moment(createdAt).unix();
      const byCreatedSort = ({
        createdAt
      }) => {
        return isEmptyDate(createdAt) ? Infinity : dateTimestamp(createdAt);
      };
      return array => orderBy(array, ...pickSortFunctions(emptyAtTop, byCreatedSort, order));
    },
    _sortByLastNameFn(emptyAtTop, order) {
      const getFamilyName = ({
        familyName = ""
      }) => toLower(familyName);
      const byLastNameSorter = clientProfile => getFamilyName(clientProfile);
      return array => {
        const result = orderBy(array, ...pickSortFunctions(emptyAtTop, byLastNameSorter, order));
        return result;
      };
    },
    _sortByReferrerNameFn(emptyAtTop, order) {
      const byReferrerNameSorter = clientProfile => getReferrerFullName(clientProfile);
      return array => orderBy(array, ...pickSortFunctions(emptyAtTop, byReferrerNameSorter, order));
    },
    _sortByClientValueFn(emptyAtTop, order) {
      const clientValue = value => Number(value);
      const byClientValueSorter = ({
        value
      }) => clientValue(value);
      return array => orderBy(array, ...pickSortFunctions(emptyAtTop, byClientValueSorter, order));
    },
    _sortByClientLabelFn(emptyAtTop, order) {
      const getLabelText = labelText => getCleanString(labelText);
      const byClientLabelSorter = ({
        labelText
      }) => getLabelText(labelText);
      return array => orderBy(array, ...pickSortFunctions(emptyAtTop, byClientLabelSorter, order));
    },
    isCurrentColorIncluded(colors, currentColor) {
      if (_includesInstanceProperty(colors).call(colors, !currentColor ? "#fff" : currentColor.toLowerCase())) return true;
      const colorAlias = defaultAssignableColors()[currentColor];
      if (colorAlias && _includesInstanceProperty(colors).call(colors, colorAlias)) return true;
      if (!this.colorExists(currentColor)) Amplitude.logHandledError(Error("Unhandled color for card profile color"), {
        cardColor: currentColor
      });
      return false;
    },
    colorExists(color) {
      var _context1;
      return !color || defaultAssignableColors()[color] || _includesInstanceProperty(_context1 = values(defaultAssignableColors())).call(_context1, color.toLowerCase());
    }
  }
};